export function toUTCDateString(dateString: string): string | null {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) {
    return null;
  }
  return date.toUTCString();
}
export function toLocalDateString(utcDateString: string): string | null {
  const date = new Date(utcDateString);
  if (isNaN(date.getTime())) {
    return null;
  }
  return date.toLocaleString();
}

export function parseBirthdateToLocalFormat(isoDateString: string) {
  const date = new Date(isoDateString);

  const day = String(date.getUTCDate()).padStart(2, "0");
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const year = date.getUTCFullYear();

  return `${day}/${month}/${year}`;
}